import { isLocalHostname } from "./Common/Config/utils/hostname";

/**
 * Deployed hosts that serve the clinic app.
 */
const appPaths = [
  "app-au.dapplecrm.com",
  "app-au-next.dapplecrm.com",
  "app.dapple.dev",
  "localhost",
  "360.juvae.com.au",
  // Glow Medical Collective on staging (the backend's white-label route
  // serves the clinic app here; `*.dapple.dev` already reaches it).
  "glow.dapple.dev",
];

/**
 * Local hostnames that serve the PATIENT app rather than the clinic app.
 *
 * Under a lane the two are distinguished only by hostname:
 * `lane0.dapple.localhost` is the clinic app, `patient-lane0.dapple.localhost`
 * and `trial-<clinic>.patientapp.localhost` are the patient app.
 */
const isLocalPatientHostname = (hostname: string): boolean =>
  hostname.startsWith("patient-") || hostname.includes(".patientapp.");

/**
 * Does this host serve the clinic app? Read once at module load by
 * `index.web.js` to pick which app to mount, and by the local WatermelonDB
 * setup, which only exists for the clinic app.
 *
 * A bare `appPaths.includes(hostname)` used to be the whole test, which meant
 * any local host other than the literal `localhost` — i.e. every lane — fell
 * through to the patient app and rendered "Domain Not Setup". Local hosts are
 * now matched on the reserved `.localhost` TLD, the same way `isDev` does it,
 * with the patient hostnames carved back out.
 */
export const isClinicApp = (() => {
  if (!window.location) return false;

  const { hostname } = window.location;

  if (appPaths.includes(hostname)) return true;

  return isLocalHostname(hostname) && !isLocalPatientHostname(hostname);
})();
